import React from 'react';
import {useTranslation} from "react-i18next";
import './i18n/config';
import './App.css';
import AirdropSection from "./components/AirdropSection";
import AboutSection from "./components/AboutSection";
import ParticipationOverview from "./components/ParticipationOverview";
import QuestsGuide from "./components/QuestsGuide";
import FAQSection from "./components/FAQSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import {useScreenDetector} from "./hooks/useScreenDetector";
import StatusSection from "./components/StatusSection";

function App() {
    const {t} = useTranslation();
    const {isMobile} = useScreenDetector();
    return (
        <div className="pellAirdropContainer">
            <Header/>
            <main>
                <AirdropSection/>
                <StatusSection/>
                <AboutSection/>
                <ParticipationOverview/>
                <QuestsGuide/>
                <FAQSection/>
                {/*<SubscribeSection/>*/}
            </main>
            <Footer/>
        </div>
    );
}

export default App;
